import {create} from "zustand";

const usePartnersStore = create((set,get) => ({
  partners: [],
  loading: false,
  getPartners: async () => {
    if (get().loading) return;
    set({loading: true});

    const partners = [
        {
            Name: "A LITTLE BIT OF...",
            Img: {
                src: "/Images/Content/CustomerServices/OurStory/Partners/ALBO.png",
                alt: "A Little Bit Of..."
            },
            Details: [
                "Food platters and charcuterie boards",
                "Available to order",
                "Made in Jersey, from work surface materials"
            ],
            Link: {
                href: "https://www.alittlebitof.uk/",
                text: "alittlebitof.uk"
                   }
        },
        {
            Name: "PENGUIN POTTERS",
            Img: {
                src: "/Images/Content/CustomerServices/OurStory/Partners/pp.png",
                alt: "Penguin Potters"
        },
            Details: [
                "Ceramics, handmade in Jersey",
                "Vases and homeware for everyday use",
                "Available to order"
            ],
            Link: {
                href: "instagram.com/pen.guin.potters",
                text: "instagram.com/pen.guin.potters"
            }
        },
        {
            Name: "PURPLE PANDA CREATIONS",
            Img: {
                src: "/Images/Content/CustomerServices/OurStory/Partners/PurplePanda.png",
                alt: "Purple Panda Creations"
            },
            Details: [
                "Laser engraved items, can be personalised",
                "Made in Jersey, member of Genuine Jersey",
                "Available to order"
            ],
            Link: {
                href: "https://purplepandacreations.com",
                text: "purplepandacreations.com"
            }
        },
        {
            Name: "FIKKERTS",
            Img: {
                src: "/Images/Content/CustomerServices/OurStory/Partners/Fikkerts.png",
                alt: "Fikkerts"
            },
            Details: [
                "Bath & Body Products",
                "Available scents: Rose, Lavender, Moss & Amber",
                "Based in Yorkshire, all products made in England"
            ],
            Link: {
                href: "https://fikkerts.com",
                text: "fikkerts.com"
            }
        },
        {
            Name: "BUSY BRAINS ACTIVITY PACKS",
            Img: {
                src: "/Images/Content/CustomerServices/OurStory/Partners/BusyBrains.png",
                alt: "Busy Brains Activity Packs"
        },
            Details: [
                "Resources for parents/carers to support brain development with fun activities",
                "Packs available from 0-3 m to 4-5 y",
                "Designed and printed in England"
            ],
            Link: {
                href: "https://busybrainsactivitypacks.co.uk",
                text: "busybrainsactivitypacks.co.uk"
            }
        },
        {
            Name: "GOODCHAPS",
            Img: {
                src: "/Images/Content/CustomerServices/OurStory/Partners/GoodChaps.png",
                alt: "GoodChaps"
            },
            Details: [
                "Order: Pup’s First Rope Set, Fetch Rope, or Tricks & Trivia Card Game",
                "Rope Toys are crafted from 100% cotton",
                "Based in Bristol, all products made in Britain"
            ],
            Link: {
                href: "https://goodchaps.co.uk",
                text: "goodchaps.co.uk"
            }
        },
        {
            Name: "ECO BATH LONDON",
            Img: {
                src: "/Images/Content/CustomerServices/OurStory/Partners/EcoBath.png",
                alt: "Eco Bath London"
            },
            Details: [
                "Natural bath & body products",
                "Order: Hair Brush, Nail Brush, Massage Glove,  Hair Drying Wrap, Head Band, Foot File",
                "Designed in England, Made in Europe"
            ],
            Link: {
                href: "https://ecobathlondon.com",
                text: "ecobathlondon.com"
            }
        }
        

    ];
    set({partners, loading: false});
}

}));

export default usePartnersStore;